import React, { useState, useCallback, useEffect } from "react";
import PropTypes from "prop-types";

const DoubleClickComponent = React.forwardRef(
  (
    { onClick, onDoubleClick, component: Component, children, ...props },
    ref
  ) => {
    const [clicks, setClicks] = useState(0);
    const [event, setEvent] = useState();

    useEffect(() => {
      let singleClickTimer;
      if (clicks === 1) {
        singleClickTimer = setTimeout(function() {
          onClick && onClick(event);
          setClicks(0);
          setEvent();
        }, 250);
      } else if (clicks === 2) {
        onDoubleClick && onDoubleClick(event);
        setClicks(0);
        setEvent();
      }
      return () => clearTimeout(singleClickTimer);
    }, [clicks, onClick, onDoubleClick, event]);

    const clickHandler = useCallback(e => {
      // persist() is needed because of event pooling https://reactjs.org/docs/legacy-event-pooling.html
      e.persist();
      !event && setEvent(e);
      setClicks(clicks => clicks + 1);
    }, []);

    return (
      <Component ref={ref} onClick={clickHandler} {...props}>
        {children}
      </Component>
    );
  }
);

DoubleClickComponent.propTypes = {
  onClick: PropTypes.func,
  onDoubleClick: PropTypes.func,
  children: PropTypes.node,
  component: PropTypes.elementType.isRequired,
};

export default DoubleClickComponent;
